import {
  AsphaltLotFilenameTemplateItem,
  AsphaltMaterialFilenameTemplateItem,
  AsphaltMixDesignFilenameTemplateItem,
} from '../classes/asphalt'
import { dateOptions } from '../utils'

export const AsphaltLotDate = new AsphaltLotFilenameTemplateItem({
  id: '1ff1c453-7651-46f2-b126-2e059db2a8c0',
  name: 'Lot Date',
  property: 'testedDate',
  ...dateOptions({ name: 'Lot Date', tableNameSingular: 'Asphalt Lot' }),
})

export const AsphaltLotId = new AsphaltLotFilenameTemplateItem({
  id: '974cf293-4890-4da2-929d-bc2c66767073',
  name: 'Lot ID',
  property: 'asphaltLotId',
  help: 'Asphalt Lot ID from Asphalt Lot table',
  exampleValue: 'PLA-0014',
})

export const AsphaltMixDesign = new AsphaltMixDesignFilenameTemplateItem({
  id: '40386f1f-a685-4dc3-8cbb-7f23ea51ff7f',
  name: 'Mix Design',
  property: 'mixDesignNumber',
  help: 'Mix Design Number from Asphalt Mix Design table',
  exampleValue: 'A141641C21',
})

export const AsphaltMixGrade = new AsphaltMixDesignFilenameTemplateItem({
  id: 'ad6a4a0c-dfdd-45be-bbd4-c9ce3811ab4f',
  name: 'Mix Grade',
  property: 'grade',
  help: 'Grade from the Asphalt Mix Design table',
  exampleValue: 'PG 64-34',
})

export const AsphaltPlacementType = new AsphaltMaterialFilenameTemplateItem({
  id: '1065ae92-4d07-4ece-b00c-56cf95eb23e3',
  name: 'Placement Type',
  property: 'placementType',
  help: 'Placement Type from Asphalt Materials table',
  exampleValue: 'HMA 700-900 Tons',
})

export const AsphaltShortName = new AsphaltMaterialFilenameTemplateItem({
  id: '399506fe-84e7-47d8-84e2-4dba35b152de',
  name: 'Placement Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Asphalt Materials table',
  exampleValue: 'HMA',
})

export type AsphaltFilename =
  | typeof AsphaltLotDate
  | typeof AsphaltLotId
  | typeof AsphaltMixDesign
  | typeof AsphaltMixGrade
  | typeof AsphaltPlacementType
  | typeof AsphaltShortName
